export enum ViewTypesList {
  ProjectPlanner = 'projectPlanner',
  SchedulePlanner = 'schedulePlanner'
}

export type ViewTypes = ViewTypesList.ProjectPlanner | ViewTypesList.SchedulePlanner;
